import React, { useState } from 'react';

const ControlPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'inventories', label: 'Item Catalog', icon: '📦' },
    { id: 'reports', label: 'Reports', icon: '📈' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-[#57402A] p-6 mt-6">
      <h3 className="text-xl font-semibold text-[#526B7C] mb-4">Control Panel</h3>
      
      <div className="flex flex-wrap gap-2 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center px-4 py-2 rounded-lg transition-colors duration-200 ${
              activeTab === tab.id
                ? 'bg-[#526B7C] text-[#FFFAED]'
                : 'bg-[#FFFAED] text-[#526B7C] hover:bg-[#526B7C] hover:text-[#FFFAED]'
            }`}
          >
            <span className="mr-2">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="bg-[#FFFAED] border border-[#57402A] rounded-lg p-4">
        {activeTab === 'dashboard' && (
          <div>
            <h4 className="font-semibold text-[#526B7C] mb-2">Dashboard Overview</h4>
            <p className="text-[#526B7C]">Welcome to the Marshmallow Tree control panel. Use the navigation above to manage your application.</p>
          </div>
        )}
        
        {activeTab === 'inventories' && (
          <div>
            <h4 className="font-semibold text-[#526B7C] mb-2">Catalog & Prices</h4>
            <p className="text-[#526B7C]">Manage your inventory items, track stock levels, and organize your products.</p>
            <div className="mt-4">
              <button className="bg-[#526B7C] text-[#FFFAED] px-4 py-2 rounded-lg hover:bg-opacity-90 transition-colors">
                Add New Item
              </button>
            </div>
          </div>
        )}
        
        {activeTab === 'reports' && (
          <div>
            <h4 className="font-semibold text-[#526B7C] mb-2">Reports & Analytics</h4>
            <p className="text-[#526B7C]">Generate reports and view analytics for your inventory and system performance.</p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white border border-[#57402A] rounded p-3">
                <h5 className="font-medium text-[#526B7C]">Inventory Report</h5>
                <p className="text-sm text-[#526B7C]">Current stock levels</p>
              </div>
              <div className="bg-white border border-[#57402A] rounded p-3">
                <h5 className="font-medium text-[#526B7C]">Usage Analytics</h5>
                <p className="text-sm text-[#526B7C]">System usage patterns</p>
              </div>
            </div>
          </div>
        )}
        
        {activeTab === 'settings' && (
          <div>
            <h4 className="font-semibold text-[#526B7C] mb-2">System Settings</h4>
            <p className="text-[#526B7C]">Configure your application settings and preferences.</p>
            <div className="mt-4 space-y-3">
              <div className="flex items-center">
                <input type="checkbox" id="notifications-react" className="mr-2" />
                <label htmlFor="notifications-react" className="text-[#526B7C]">Enable notifications</label>
              </div>
              <div className="flex items-center">
                <input type="checkbox" id="auto-backup" className="mr-2" defaultChecked />
                <label htmlFor="auto-backup" className="text-[#526B7C]">Auto backup data</label>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ControlPanel;
